<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            <CRow style="width:100%">
              <CCol md="12" lg="12" xl="12"> Inventario </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <div class="inventario-panel">
              <section
                class="inventario-panel-row"
                v-for="(row, i) in panel"
                v-if="row.apps.length>0"
                :key="i"
              >
                <h4 class="inventario-panel-subtitle">{{ row.subtitle }}</h4>
                <article
                  class="inventario-panel-col"
                  v-for="(item, ix) in row.apps"
                  :key="ix"
                >
                  <router-link :to="item.to || '/'">
                    <i :class="item.icon"></i>
                    <span>{{ item.name }}</span>
                  </router-link>
                </article>
              </section>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CredentialMixin from '../mixins/CredentialMixin';

export default {
  name: "PanelPage",
  components: {},
  mixins: [CredentialMixin],
  data() {
    return {};
  },

  created() {},

  computed: {
    panel(){
      return this._panel.map(m=>{
        return {
          ...m,
          apps: m.apps.filter(f=>{
            if(f.credential){
              return this.hasTheCredential(f.credential);
            }
            return true;
          })
        }
      })
    },
    _panel() {
      return [
        {
          subtitle: "Requisiciones",
          apps: [
            {
              name: "Requisiciones",
              to: {
                name: "Requisiciones"
              },
              icon: "fa fa-file-o",
              credential: "@documento:schema=requisiciones\\|.*consultar"
            },
            {
              name: "Surtido de requisiciones",
              to: {
                name: "SurtirOrdenCompra"
              },
              icon: "fa fa-caret-square-o-down"
            },
            {
              name: "Ordenes de compra",
              to: {
                name: "OrdenesCompra"
              },
              icon: "fa fa-shopping-cart",
              credential: "@documento:schema=ordenes_compra\\|.*consultar"
            }
          ]
        },
        {
          subtitle: "Movimientos",
          apps: [
            {
              name: "Entradas",
              to: {
                name: "Entrada"
              },
              icon: "fa fa-sign-in",
              credential: "@documento:schema=entradas\\|.*consultar"
            },
            {
              name: "Traspasos",
              to: {
                name: "Traspasos"
              },
              icon: "fa fa-retweet",
              credential: "@documento:schema=traspasos\\|.*consultar"
            },
            {
              name: "Salidas",
              to: {
                name: "Salida"
              },
              icon: "fa fa-sign-out",
              credential: "@documento:schema=salidas\\|.*consultar"
            }
          ]
        },
        {
          subtitle: "Consulta",
          apps: [
            {
              name: "Inventario actual",
              to: {
                name: "InventarioActual"
              },
              icon: "fa fa-files-o",
              credential: "@view:schema=inventario|call_action=actual"

            },
            {
              name: "Inventario histórico",
              to: {
                name: "InventarioHistorico"
              },
              icon: "fa fa-clock-o",
              credential: "@view:schema=inventario|call_action=historico"
            }
          ]
        },
        {
          subtitle: "Empaques",
          apps: [
            {
              name: "Solicitudes de empaque",
              to: {
                name: "SolicitudEmpaque"
              },
              icon: "fa fa-archive",
              credential: "@documento:schema=solicitudes_empaques\\|.*consultar"
            },
            {
              name: "Devoluciones de empaque",
              to: {
                name: "DevolucionEmpaque"
              },
              icon: "fa fa-undo",
              credential: "@documento:schema=devoluciones_empaques\\|.*consultar"
            }
          ]
        }
      ];
    }
  },

  methods: {}
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.line {
  width: 100%;
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.z-custom {
  z-index: 1;
}
.z-custom-2 {
  z-index: 4;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}

.custom-width-btn {
  width: 40%;
}
.custom-heigth-btn {
  width: 100%;
}
.custom-font-size {
  font-size: 1rem;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
<style lang="scss" scoped>
.inventario-panel {
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 90%;
  margin: 0 auto;
  section.inventario-panel-row {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    h4.inventario-panel-subtitle {
      width: 100%;
      margin: 0;
      text-transform: capitalize;
    }
    article.inventario-panel-col {
      width: 120px;
      height: 120px;
      background-color: #172b4d;
      border-radius: 20px;
      gap: 10px;
      a {
        color: #fff;
        display: grid;
        font-size: 17px;
        width: 100%;
        height: 100%;
        text-align: center;
        grid-template-rows: 1fr 1fr;
        align-content: center;
        &:hover {
          text-decoration: none;
        }
        i {
          font-size: 32px;
          align-self: end;
        }
      }
    }
  }
}
</style>
